import { useResellersList } from "modules/resellers";
import { ItemsTable } from "ui";

import { useResellersColumns } from "../../hooks";
import { StatisticsBlockLayout } from "../../layouts";

import styles from "../../styles/TableStyles.module.scss";

const TopSellingProducts = () => {
  const { resellers } = useResellersList({
    defaultSorting: [{ id: "TotalSales", desc: true }]
  });

  const { columns } = useResellersColumns();

  return (
    <StatisticsBlockLayout
      title="Top Resellers"
      navigationPass="/users/all"
      navigationOptions={{
        state: { defaultSorting: [{ id: "TotalSales", desc: true }] }
      }}
    >
      <ItemsTable
        columns={columns}
        data={resellers?.slice(0, 7) ?? []}
        isLoading={false}
        className={styles.statistics__table}
      />
    </StatisticsBlockLayout>
  );
};

export default TopSellingProducts;
